import { getSystemState } from "@/features/system-states/system-state";
import { SystemStatePage } from "@/features/system-states/system-state-page";
import SysPermissionDenied from "@/features/system-states/sys-permission-denied";

export default function PermissionDeniedPage() {
  return (
    <SystemStatePage meta={getSystemState("SYS-02")}>
      <SysPermissionDenied />
    </SystemStatePage>
  );
}
